module.exports = __webpack_public_path__ + "static/media/icon-corner-scalloped.e4f7933f.svg";